import { Controller } from "@hotwired/stimulus";
import autocomplete from "autocompleter";

export default class extends Controller {
  connect() {
    this.defaultItems = this.element.dataset.defaultItems
      ? JSON.parse(this.element.dataset.defaultItems)
      : [];

    this.autocomplete = autocomplete({
      input: this.element,
      preventSubmit: true,
      minLength: 0,
      showOnFocus: true,
      onSelect: (item) => {
        this.element.value = item.label;
        this.dispatch("select", { detail: item });
      },
      render: this.renderItem,
      fetch: this.loadItems,
    });
  }

  disconnect() {
    this.autocomplete.destroy();
  }

  loadItems = (search, resolve) => {
    const lowerSearch = search.toLowerCase();

    if (search) {
      const queryParams = new URLSearchParams({ q: search });

      fetch("/address_suggestions?" + queryParams)
        .then((response) => response.json())
        .then((data) => {
          const filteredItems = this.defaultItems.filter((item) => {
            return (
              item.label.toLowerCase().includes(lowerSearch) ||
              (item.name && item.name.toLowerCase().includes(lowerSearch))
            );
          });

          resolve([
            ...filteredItems,
            ...data.filter(
              (item) => !filteredItems.find((i) => i.label === item.label),
            ),
          ]);
        })
        .catch(() => {
          resolve([]);
        });
    } else {
      resolve(this.defaultItems);
    }
  };

  renderItem(item) {
    const div = document.createElement("div");

    if (item.name) {
      div.textContent = [item.name, item.label].join(", ");
    } else {
      div.textContent = item.label;
    }

    return div;
  }
}
